<template>
    <div class="expedient-files">
        <div class="new-media d-flex align-items-start justify-content-center flex-column">
            <v-uploader
                ref="uploader"
                name="media"
                route-prefix="api/media"
                :sortable="false"
                :multiple="true"
                :validation-rules="{ accept: ['image/png', 'image/jpeg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'text/plain'] }"
                :afterUpload="onChange"
                @removed="onChange">
            </v-uploader>
        </div>
    </div>
</template>

<script>
import VUploader from "../../upload/VUploader";

export default {
    name: "files-expedient",
    components: {
        VUploader
    },
    data() {
        return {
            files: [],
        }
    },
    methods: {
        acceptModal() {
            // TODO: Do the stuff you want when finished

            this.$emit('accepted', this.files);
            this.closeModal();
        },
        onChange() {
            this.files = this.$refs.uploader.mediaLibrary.state.media;
        },
    }
}
</script>
